import { IPhatHanhDichVuMultipleRequest } from "../../../model/request/hoa-don-dien-tu/IPhatHanhDichVuMultipleRequest";
import { IDichVuThanhToan } from "../../../model/respone/dich-vu/IDichVuThanhToan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDichVuThanhToanActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDichVuThanhToan[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDichVuThanhToan,
  SAVE_SUCCESS: {} as IDichVuThanhToan,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IDichVuThanhToan,
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],

  PHAT_HANH_HOA_DON_START: {} as IPhatHanhDichVuMultipleRequest,
  PHAT_HANH_HOA_DON_SUCCESS: undefined,
  PHAT_HANH_HOA_DON_ERROR: "",

  DONG_BO_HOA_DON_STATUS_START: {} as IPhatHanhDichVuMultipleRequest,
  DONG_BO_HOA_DON_STATUS_SUCCESS: undefined,
  DONG_BO_HOA_DON_STATUS_ERRR: "",
};
export const eDichVuThanhToanActionIds = generateActionTypeIds(
  eDichVuThanhToanActionsObj,
  "DICH_VU_THANH_TOAN"
);
export type IDichVuThanhToanActionTypes = IGenericActionType<
  typeof eDichVuThanhToanActionsObj,
  "DICH_VU_THANH_TOAN"
>;
